var render, staticRenderFns
import script from "./LoadModelsMixin.vue?vue&type=script&lang=js"
export * from "./LoadModelsMixin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2367eac",
  null
  
)

export default component.exports